import {
  ArrowLeftOutlined,
  CloseOutlined,
  LinkOutlined,
  TeamOutlined,
  UserAddOutlined,
  UserDeleteOutlined,
  UserSwitchOutlined,
} from '@ant-design/icons'
import { Button, Card, Col, Divider, Modal, Row, Tooltip } from 'antd'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { Icon } from '../../../components'

import { ConvertAndConnectUserForm, ManagerConnectForm, ManagerLeavingForm, NewCorporateUserForm } from './actions'

const menu = [
  {
    actionName: 'userList',
    description: 'A list of all corporate users connected to this store',
    icon: <TeamOutlined className="icon" />,
    title: 'Connected users list', //users with store id
  },
  {
    actionName: 'newUser',
    description: 'Create a corporate user from scratch',
    icon: <UserAddOutlined className="icon" />,
    title: 'New corporate user', //new corporate user with connected store
  },
  {
    actionName: 'managerLeaving',
    description: 'Apply restrictions on the selected user',
    icon: <UserDeleteOutlined className="icon" />,
    title: 'Store Manager leaving', //list users with store ids -> date picker -> apply restrictions
  },
  {
    actionName: 'connectFormerManager',
    description: 'Connect an existing, unassigned corporate user to this store',
    icon: <LinkOutlined className="icon" />,
    title: 'Connect a former Store Manager', //list corporate users without store ids -> connect to store
  },
  {
    actionName: 'convertAndConnectAUser',
    description: 'Convert the selected regular user to corporate from the existing users list',
    icon: <UserSwitchOutlined className="icon" />,
    title: 'Convert and connect a user', // list regular users -> convert to corporate and connect to store
  },
]

const StoreManagerModal = ({ hideModal, selectedStore }) => {
  const [selectedMenu, setSelectedMenu] = useState(null)

  const props = {
    resetSelectedMenu: () => setSelectedMenu(null),
    selectedStore,
  }

  const actionComponents = {
    connectFormerManager: <ManagerConnectForm {...props} />,
    convertAndConnectAUser: <ConvertAndConnectUserForm {...props} />,
    managerLeaving: <ManagerLeavingForm {...props} />,
    newUser: <NewCorporateUserForm {...props} />,
  }

  /* eslint-disable */
  const handleCardClick = (menuItem) => {
    switch (menuItem.actionName) {
      case 'userList':
        window.open(
          `users?items_per_page=50&page=1&sort_by=created_at+DESC&store_id=${selectedStore.id}`,
          '_blank',
          'rel=noopener noreferrer',
        )
        break
      default:
        setSelectedMenu(menuItem)
    }
  }
  /* eslint-enable */

  return (
    <Modal
      className="store-management-modal"
      closeIcon={<CloseOutlined />}
      footer={null}
      onCancel={hideModal}
      open
      style={{ marginTop: '35px' }}
      title={`Connected Users Management for ${selectedStore.name} `}
    >
      <Divider>
        {selectedMenu && (
          <Button onClick={() => setSelectedMenu(null)} type="link">
            <ArrowLeftOutlined />
          </Button>
        )}
        {selectedMenu?.title}
      </Divider>

      {selectedMenu && actionComponents[selectedMenu.actionName]}

      {!selectedMenu && (
        <Row gutter={16} style={{ rowGap: '20px' }}>
          {menu.map((item) => (
            <Col key={item.actionName} span={8}>
              <Card className="store-management-card" onClick={() => handleCardClick(item)}>
                <p className="title">
                  {item.icon} <span>{item.title}</span>
                </p>

                <p className="description">{item.description}</p>
              </Card>
            </Col>
          ))}
        </Row>
      )}
      <Row justify="end" style={{ marginTop: 20 }}>
        <Tooltip title="Userguide">
          <Icon
            data-testid="userGuideIcon"
            name="userGuide"
            onClick={() => window.open('https://sites.google.com/terracycle.com/loop-it-team-space/user-manuals/mobile-admin-user-manuals/corporate-user-management', '_blank')}
            type="userGuide"
          />
        </Tooltip>
      </Row>
    </Modal>
  )
}

StoreManagerModal.propTypes = {
  hideModal: PropTypes.func.isRequired,
  selectedStore: PropTypes.object.isRequired,
}

export default StoreManagerModal
